<template>
	<div>
<!--		<breadcrumb />-->
    <Breadtabsheader/>
		<div class="h-content">
			<div class="h-optionItem">
				<div class="h-optionItemin">
					<ul>
						<li>
							<a>
								<div class="h-oItemIntro h-disTable h-oItem-icon1">
									<div class="h-tableCell" @click="orderPage" style="cursor: pointer;">
										<p>订单全流程</p>
										<!-- <span>新建计划</span> -->
									</div>
								</div>
							</a>
						</li>
						<li>
							<a>
								<div class="h-oItemIntro h-disTable h-oItem-icon2">
									<div class="h-tableCell" @click="cgorderPage" style="cursor: pointer;">
										<p>采购订单</p>
										<!-- <span>新建需求</span> -->
									</div>
								</div>
							</a>
						</li>
                        <li>
							<a>
								<div class="h-oItemIntro h-disTable h-oItem-icon3">
									<div class="h-tableCell" @click="fanliPage" style="cursor: pointer;">
										<p>返利追踪</p>
										<!-- <span>转化项目</span> -->
									</div>
								</div>
							</a>
						</li>
						<!-- <li>
							<a>
								<div class="h-oItemIntro h-disTable">
									<div class="h-tableCell">
										<p class="h-txtCenter">+ 增加快捷入口</p>
									</div>
								</div>
							</a>
						</li> -->
					</ul>
				</div>
			</div>
			<div class="h-row">
				<div class="h-rowIn" style="width: 61.5%;overflow:hidden">
					<div class="h-rowBox" style="height: 7.4rem;">
						<div class="h-rowTitle">
							<div class="h-disTable">
								<div class="h-tableCell" style="height:100%;display:flex;justify-content:space-between;align-items:center;">
									<h1>销量总量</h1>
									<div class="h-calendarSelect" style="margin-left: 0;">
										<div class="h-csBox">
											<el-select v-model="yearValue" placeholder="请选择" @change="getSaleRank">
												<el-option v-for="item in yearOptions" :key="item.value"
													:label="item.label" :value="item.value">
												</el-option>
											</el-select>
										</div>
										<span class="h-selectLine">-</span>
										<div class="h-csBox">
											<el-select v-model="monthValue" placeholder="请选择"
												@change="getSaleRank">
												<el-option v-for="item in monthOptions" :key="item.value"
													:label="item.label" :value="item.value">
												</el-option>
											</el-select>
										</div>
									</div>
									<div class="selecBox">
										<div class="button" :class="{'active':indx==index}" v-for="(item,index) in buttonlist" :key="index" @click="tab(index)">{{item}}</div>
									</div>
								</div>
							</div>
						</div>
						<div class="h-rowCon">
							<div class="blankimg" v-if="blank0" style="text-align: center;">
								<img src="../../../assets/images/mylittle.png"  style="width: 80%;">
							</div>
							<div class="agentBox" style="height: 5rem;overflow-y: auto;padding-top: 20px;" v-if="proFlag">
								<div class="agent" v-for="(item,index) in productList" :key="index">
									<div class="agentTop">
										<div class="circle" :style="{'border-color':'#005cfd'}"></div>
										<div class="titles">{{item.prodName}}</div>
									</div>
									<div class="agentBottom">
										<div class="zhaobox" :style="{'width':item.target/20+'%'}">
											<div class="zhao" :style="{'background':'#005cfd','width':item.actual/20+'%'}">
												<div class="imgs">已实现{{item.actual}}万</div>
											</div>
										</div>
										<div class="nums">{{item.target}}万</div>
									</div>
								</div>
							</div>
							<div class="agentBox" style="height: 5rem;overflow-y: auto;padding-top: 20px;" v-if="agentFlag">
								<div class="agent" v-for="(item,index) in agentSale" :key="index">
									<div class="agentTop">
										<div class="circle" style="{'border-color':'#005cfd'}"></div>
										<div class="titles">{{item.username}}</div>
									</div>
									<div class="agentBottom">
										<div class="zhaobox" :style="{'width':item.monthlyGoals/5+'%'}">
											<div class="zhao" :style="{'background':'#005cfd','width':item.actual*100/item.monthlyGoals+'%'}">
												<div class="imgs">已实现{{item.actual}}万</div>
											</div>
										</div>
										<div class="nums">{{item.monthlyGoals}}万</div>
									</div>
								</div>
							</div>
							<div class="agentBox" style="padding-top: 0;" v-if="!blank0">
								<div class="lines" style="margin-top:50px;"></div>
								<div class="lineBox">
									<div class="test">销售目标</div>
									<div v-if="proFlag" class="linelist" v-for="(item1,index1) in shixianlist" :key="index1">{{item1}}</div>
									<div v-if="agentFlag" class="linelist" v-for="(item2,index2) in shixianlistagent" :key="index2">{{item2}}</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<!--代办-->
				<!--代办-->
				<!--代办-->
				<tasklist divheight="7.4rem" :pagesize="10"/>
				<!--代办-->
				<!--代办-->
				<!--代办-->
			</div>
			<div class="h-row">
				<div class="h-rowIn">
					<div class="h-rowBox">
						<div class="h-rowTitle">
							<div class="h-disTable">
								<div class="h-tableCell" style="height:100%;display:flex;justify-content:space-between;align-items:center;">
									<h1>金额报表</h1>
									<div class="h-calendarSelect" style="margin-left: 0;">
										<div class="h-csBox">
											<el-select v-model="yearValue2" placeholder="请选择" @change="getSaleRank">
												<el-option v-for="item in yearOptions" :key="item.value"
													:label="item.label" :value="item.value">
												</el-option>
											</el-select>
										</div>
										<span class="h-selectLine">-</span>
										<div class="h-csBox">
											<el-select v-model="monthValue2" placeholder="请选择"
												@change="getSaleRank">
												<el-option v-for="item in monthOptions" :key="item.value"
													:label="item.label" :value="item.value">
												</el-option>
											</el-select>
										</div>
									</div>
									<span>
										 <el-select v-model="area" placeholder="区域选择">
											<el-option
											v-for="item in options1"
											:key="item.value"
											:label="item.label"
											:value="item.value">
											</el-option>
										</el-select>
										<el-select style="margin-left:20px;" v-model="protype" placeholder="型号选择">
											<el-option
											v-for="item in options2"
											:key="item.value"
											:label="item.label"
											:value="item.value">
											</el-option>
										</el-select>
									</span>
								</div>
							</div>
						</div>
						<div class="h-rowCon">
							<div class="h-funnelChart">
								<div class="h-funnelChartIn" style="display:flex;width:100%;margin:0;">
									<div class="h-pieChart" id="h_line1Chart" style="width: 33%; height: 6.7rem;"></div>
									<div class="h-pieChart" id="h_line3Chart" style="width: 33%; height: 6.7rem;"></div>
									<div class="h-pieChart" id="h_line4Chart" ref="h_line4Chart" style="width: 33%; height: 6.7rem;"></div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
    import tasklist from '@/components/task/mytask.vue';
	import ss from "../../../api/SystemService";
    export default {
        components:{
            tasklist
        },
        data() {
            return {
				productList:"",
				indx:0,
				buttonlist:['经销商','产品'],
				options: [{
				value: '选项1',
				label: '已完成'
				}, {
				value: '选项2',
				label: '未完成'
				}, {
				value: '选项3',
				label: '未开始'
				}],
				options1: [{
				value: '选项1',
				label: '国内'
				}, {
				value: '选项2',
				label: '国外'
				}],
				options2: [{
				value: '选项1',
				label: '型号1'
				}, {
				value: '选项2',
				label: '型号2'
				}, {
				value: '选项3',
				label: '型号3'
				}],
				value: '',
				area: '',
				protype: '',
				shixianlist:["0","100万","200万","300万","400万","500万"],
				shixianlistagent:["0","400万","800万","1200万","1600万","2000万"],
				calenderValue:new Date(),
			        yearOptions:[{
			        	value:'2017',
			        	label:'2017'
			        },{
			        	value:'2018',
			        	label:'2018'
			        },{
			        	value:'2019',
			        	label:'2019'
			        },{
			        	value:'2020',
			        	label:'2020'
			        }],
			        monthOptions:[{
			        	value:'1',
			        	label:'1月'
			        },{
			        	value:'2',
			        	label:'2月'
			        },{
			        	value:'3',
			        	label:'3月'
			        },{
			        	value:'4',
			        	label:'4月'
			        },{
			        	value:'5',
			        	label:'5月'
			        },{
			        	value:'6',
			        	label:'6月'
			        },{
			        	value:'7',
			        	label:'7月'
			        },{
			        	value:'8',
			        	label:'8月'
			        },{
			        	value:'9',
			        	label:'9月'
			        },{
			        	value:'10',
			        	label:'10月'
			        },{
			        	value:'11',
			        	label:'11月'
			        },{
			        	value:'12',
			        	label:'12月'
			        }],
			        yearValue:new Date().getFullYear()+"年",
			        monthValue:new Date().getMonth()+1+"月",
					yearValue2:new Date().getFullYear()+"年",
					monthValue2:new Date().getMonth()+1+"月",
					lineChart01:null,
					lineChart03:null,
					lineChart04:null,
					blank0:false,
					agentSale:"",
					proFlag:false,
					agentFlag:false,
            }
        },
        methods: {
			getProductSale(){
				ss.firstPageService.getProductSale({month:this.getMonthStr(this.yearValue,this.monthValue,'')}).then(rd=>{
					this.productList = rd.obj;
					if(rd.obj!=null && rd.obj.length > 0){
						this.blank0 = false;
					}else{
						this.blank0 = true;
					}
				});
			},
			getSaleRank(){
				if(this.indx == 0){
					this.getAgentMonthlySale();
				}else{
					this.getProductSale();
				}
			},
			getAgentMonthlySale(){
				ss.firstPageService.getAgentMonthlySale({month:this.getMonthStr(this.yearValue,this.monthValue,'-')}).then(rd=>{
					this.agentSale = rd;
					if (rd.length==0){
						this.blank0 = true;
					}else{
						this.blank0 = false;
					}
				})
			},
			orderPage(){
				this.$router.push({path:"/dingd/orderProcess"});
			},
			cgorderPage(){
				this.$router.push({path:"/dingd/purchaselist"});
			},
			fanliPage(){
				this.$router.push({path:"/establish/contractlist"});
			},
			handleYearClick(){
				this.calenderValue = (this.yearValue+"-"+this.monthValue).split("月")[0]
			},
			tab(index){
				this.indx = index;
				if(index == 0){
					this.agentFlag=true;
					this.proFlag=false;
					this.getAgentMonthlySale();
				}else{
					this.agentFlag=false;
					this.proFlag=true;
					this.getProductSale();
				}
			},
			handleMonthClick(){
				this.calenderValue = this.yearValue.split("年")[0]+"-"+this.monthValue
			},
			handleDateClick(a){
				this.yearValue = a.getFullYear()+"年";
				this.monthValue = a.getMonth()+1+"月"
			},
			lineChart1(){
				this.lineChart01 = this.$echarts.init(document.getElementById('h_line1Chart'));
				let option = {
                    title : {
                        text: '下单金额',
                        x:'center',
                        y:'70%'
                    },
                    tooltip : {
                        trigger: 'item',
                        formatter: "{a} <br/>{b} ({d}%)"
                    },
                    legend: {
                        orient: 'vertical',
                        left: 'center',
                        data: [],
                        bottom:'10%',
                    },
                    series : [
                        {
                            name: '下单金额',
                            barWidth: '50%',
                            type: 'pie',
                            radius : '35%',
                            center: ['50%', '40%'],
                            data:[],
                            itemStyle: {
                                normal:{
                                    color: function(params) {
                                        let colorList = [
                                            "#5ba9fe",
                                            "#fec10c"
                                        ];
                                        return colorList[params.dataIndex];
                                    },
                                },
                                emphasis: {
                                    shadowBlur: 10,
                                    shadowOffsetX: 0,
                                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                                }
                            }
                        }
                    ]
				}
				this.lineChart01.setOption(option);
				
            },
            lineChart3(){
				this.lineChart03 = this.$echarts.init(document.getElementById('h_line3Chart'));
				let option = {
                    title : {
                        text: '订单图表',
                        x:'center',
                        y:'70%'
                    },
                    tooltip : {
                        trigger: 'item',
                        formatter: "{a} <br/>{b} ({d}%)"
                    },
                    legend: {
                        orient: 'vertical',
                        left: 'center',
                        data: [],
                        bottom:'6%',
                    },
                    series : [
                        {
                            name: '订单图表',
                            barWidth: '50%',
                            type: 'pie',
                            radius : '35%',
                            center: ['50%', '40%'],
                            data:[],
                            itemStyle: {
                                normal:{
                                    color: function(params) {
                                        let colorList = [
                                            "#5ba9fe",
                                            "#fec10c",
                                            "#7467ff"
                                        ];
                                        return colorList[params.dataIndex];
                                    },
                                },
                                emphasis: {
                                    shadowBlur: 10,
                                    shadowOffsetX: 0,
                                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                                }
                            }
                        }
                    ]
				}
				this.lineChart03.setOption(option);
				
            },
            lineChart4(){
				this.lineChart04 = this.$echarts.init(document.getElementById('h_line4Chart'));
				let option = {
                    title : {
                        text: '订单保障度',
                        x:'center',
                        y:'70%'
                    },
                    tooltip : {
                        trigger: 'item',
                        formatter: "{a} <br/>{b} : {c} ({d}%)"
                    },
                    legend: {
                        orient: 'vertical',
                        left: 'center',
                        data: ['已有库存：0个','已有排产：0个'],
                        bottom:'10%',
                    },
                    series : [
                        {
                            name: '订单保障度',
                            barWidth: '50%',
                            type: 'pie',
                            radius : '35%',
                            center: ['50%', '40%'],
                            data:[
                                {value:0, name:'已有库存：0个'},
                                {value:0, name:'已有排产：0个'},
                            ],
                            itemStyle: {
                                normal:{
                                    color: function(params) {
                                        let colorList = [
                                            "#5ba9fe",
                                            "#fec10c"
                                        ];
                                        return colorList[params.dataIndex];
                                    },
                                },
                                emphasis: {
                                    shadowBlur: 10,
                                    shadowOffsetX: 0,
                                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                                }
                            }
                        }
                    ]
				}
				this.lineChart04.setOption(option);
				
			},
			getMonthStr(yearValue, monthValue, separator){
				var year = yearValue.split('年')[0];
				var month = monthValue.split('月')[0];
				month = month.length==1?'0'+month:month;
				return year + separator + month;
			},
        },
		mounted(){
			this.lineChart1();
            this.lineChart3();
			this.lineChart4();
			
			let that = this;
			window.addEventListener('resize',function () {
			   that.lineChart01.resize();
			   that.lineChart03.resize();
			   that.lineChart04.resize();
			});
			
			//经销商销量
			this.agentFlag=true;
			this.getAgentMonthlySale();
			
			//金额报表
			ss.firstPageService.getOrderPrice().then(rd=>{
				var legend=[];
				var data=[];
				legend.push('缺款：￥'+rd.credit);
				legend.push('正常：￥'+rd.normal);
				data.push({value:rd.credit,name:'缺款：￥'+rd.credit});
				data.push({value:rd.normal,name:'正常：￥'+rd.normal});
				//下单金额
				this.lineChart01.setOption({
					legend: {
						data:legend
					},
					series:[{
						data:data
					}]
				});
				var legend1=[];
				var data1=[];
				legend1.push('缺款：￥'+rd.credit);
				legend1.push('发货：￥'+rd.fahuo);
				legend1.push('已下单：￥'+rd.waitfahuo);
				data1.push({value:rd.credit,name:'缺款：￥'+rd.credit});
				data1.push({value:rd.fahuo,name:'发货：￥'+rd.fahuo});
				data1.push({value:rd.waitfahuo,name:'已下单：￥'+rd.waitfahuo});
				//订单图表
				this.lineChart03.setOption({
					legend: {
						data:legend1
					},
					series:[{
						data:data1
					}]
				});
			});
			//订单保障度
			
		},
    }
</script>

<style scoped>
.agentBox{
	width: 100%;
	padding: 0 0.2rem;
}
.agentBox .agent{
	display: flex;
	flex-direction: column;
	justify-content: center;
	margin-top: 0.18rem;
}
.agentBox .agent:first-child{
	margin-top:0
}
.agentBox .agent .agentTop{
	display: flex;
	justify-content: flex-start;
	align-items: center;
}
.agentBox .agent .agentTop .circle{
	width: 12px;
	height: 12px;
	border: 3px solid #64a5f8;
	margin-right: 10px;
	border-radius: 50%;
}
.agentBox .agent .agentTop .titles{
	font-size: 16px;
	color: #a9a9a9;
}
.agentBox .agent .agentBottom{
	margin-top: 0.15rem;
	display: flex;
}
.agentBox .agent .agentBottom .zhaobox{
	width: 90%;
	height: 0.16rem;
	background: #e2f1ff;
	border-radius: 8px;
	position: relative;
}
.agentBox .agent .agentBottom .nums{
	width: 10%;
	font-size: 16px;
	color: #a9a9a9;
	text-align: right;
}
.agentBox .agent .agentBottom .zhaobox .zhao{
	position: absolute;
	top: 0;
	left:0;
	width: 16.5%;
	height: 0.16rem;
	border-radius: 8px;
	background: #005cfd;
	transition: all 0.3s;
}
.agentBox .agent .agentBottom .zhaobox:hover .zhao .imgs{
	display: block;
}
.agentBox .agent .agentBottom .zhaobox .zhao .imgs{
	width: 126px;
	height: 57px;
	background: url(../../../assets/images/titp.png);
	position: absolute;
	top: -60px;
	right: -90px;
	color: #949b9e;
	font-size: 16px;
	text-align: center;
	line-height: 40px;
	display: none;
}
.agentBox .lines{
	width: 100%;
	height: 1px;
	background: #f6f6f6;
	margin-top: 40px;
}
.agentBox .lineBox{
	position: relative;
	width: 100%;
	display: flex;
}
.agentBox .lineBox .linelist{
	width: 16.5%;
	margin-top: 10px;
	text-align: center;
	font-size: 14px;
	color:#4d4d4d;
}
.agentBox .lineBox .test{
	position: absolute;
	top: -25px;
	left: 0;
	font-size: 14px;
	color:#4d4d4d;
}
.selecBox{
	display: flex;
}
.selecBox .button{
	width: 85px;
	height: 32px;
	color: #767676;
	text-align: center;
	line-height: 28px;
	border:1px solid #dddfe4;
	background: #fff;
	cursor: pointer;
	font-size: 0.16rem;
}
.selecBox .button.active{
	background: #2686e7;
	color: #fff;
	border-color: #2686e7;
}
</style>
<style>
.h-tableCell .el-input__inner {
	width: 1.3rem;
    color: #DCDFE6;
    border-radius: 0;
    height: 0.32rem;
    line-height: 0.28rem;
    border: 1px solid #DCDFE6;
    font-size: 0.16rem;
    padding-right: 0.3rem;
    padding-left: 0.15rem;
}
.h-tableCell .el-input__icon{
	line-height: 0;
}
.fenyes .h-pagiLabel{
	display: none;
}
.fenyes .el-pagination .el-pagination__sizes{
	display: none;
}
</style>
